<template>
<div class="bread-crumb-container">
    <div class="bread-crumb-title">{{$t("会议#!!!#src/pages/H5/Cloud/components/breadCrumb/MettingBreadCrumb.vue_1")}}</div>
    <div class="bread-crumb-separator">/</div>
    <div class="bread-crumb-title">{{$t("历史会议#!!!#src/pages/H5/Cloud/components/breadCrumb/MettingBreadCrumb.vue_1")}}</div>
  </div>
</template>

<script>
export default {
  name: "MettingBreadCrumb",
  props: [],
  emits: [],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.bread-crumb-container {
  cursor: not-allowed;
  display: flex;
  flex-direction: row;
  align-items: center;
  .bread-crumb-separator {
    line-height: 21px;
    font-size: 12px;
    color: #c0c4cc;
    margin: 0 6px;
  }
  .bread-crumb-title {
    line-height: 21px;
    font-size: 12px;
    color: #c1c5c5;
  }
}
</style>
